import { Pujcovna } from '@/modules/pujcovna';
import { Sklad } from '@/modules/sklad';
import { Partner } from '@/modules/kartoteka/partner';
import { Ciselniky } from '@/modules/ciselnik';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Uzaverka } from '@/modules/uzaverka';
import { Servis } from '@/modules/servis';
import { Crm } from '@/modules/crm';
import { NoveVozy } from '@/modules/noveVozy';
import { Administrace } from '@/modules/administrace';
import { Sestavy } from '@/modules/sestavy';
import { Oem } from '@/modules/oem';
import { WmsModule } from '@/modules/wmsModule';
import { Accounting } from '@/modules/Accounting';

import { menuBase } from './menu';

export const menuTree = menuBase;

menuTree.addItem(WmsModule.menu, 'icon-cog');

menuTree.addItem({ name: 'KZV_Zakaznici', route: Partner.name }, 'icon-activities');
menuTree.addItem({ name: 'KZV_Vozidla', route: Vozidlo.name }, 'icon-cars');

menuTree.addItem(Servis.menu, 'icon-tools');
menuTree.addItem(Crm.menu, 'icon-activity');
menuTree.addItem(Sklad.menu, 'icon-stock');
menuTree.addItem(NoveVozy.menu, 'icon-car-new');
// menuTree.addItem(OjeteVozy.menu, 'icon-car-old'); legacy MPOV
menuTree.addItem(Pujcovna.menu, 'icon-rental-car');
menuTree.addItem(Ciselniky.menu, 'icon-file-storage');
menuTree.addItem(Uzaverka.menu, 'icon-agenda-1');
menuTree.addItem(Sestavy.menu, 'icon-cog');
menuTree.addItem(Accounting.menu,'icon-cog');
menuTree.addItem(Administrace.menu, 'icon-cog');
menuTree.addItem(Oem.menu, 'icon-cog');

